export default __webpack_public_path__ + "static/media/privacy.ecc8704f.svg";